// Dependencies.
import styled from 'styled-components'
import { useEffect, useContext, useState, useCallback } from 'react'

import { UserContext } from '../context'

// Div.
const Div = styled.div``

declare global {
  interface Window {
    captchaOnLoad: () => void
    grecaptcha: ReCaptchaInstance
  }
}
interface ReCaptchaExecuteOptions {
  action: string
}

interface ReCaptchaRenderOptions {
  sitekey: string
  callback: (token: string) => void
  'expired-callback': () => void
  'error-callback': () => void
}
interface ReCaptchaInstance {
  ready: (cb: () => any) => any
  execute: (options: ReCaptchaExecuteOptions) => Promise<string>
  render: (id: string, options: ReCaptchaRenderOptions) => any
  reset: (id: number) => any
}
// Props.
interface Props {
  onReady: () => void
  onResponse: (token: string) => void
}

const onErrorCallback = () => {
  console.log('reCAPTCHA error has occured')
}
// Google reCAPTCHA.
export const GooglereCAPTCHA: React.FC<Props> = (props) => {
  const { onReady, onResponse } = props

  const [isReady, setIsReady] = useState(false)
  const [widgetId, setWidgetId] = useState(-1)

  const onCallback = useCallback(
    (token: string) => {
      onResponse(token)
    },
    [onResponse],
  )
  const onExpiredCallback = useCallback(() => {
    onResponse('')
  }, [onResponse])

  const onLoad = useCallback(() => {
    const widget = window.grecaptcha.render('google-recaptcha', {
      sitekey:
        process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA ||
        '6Lc2R6QUAAAAAPz1Cpc-U9pauDEqwtx29x2avwzK',
      callback: onCallback,
      'expired-callback': onExpiredCallback,
      'error-callback': onErrorCallback,
    })
    setWidgetId(widget)

    window.grecaptcha.ready(() => {
      setIsReady(true)
      onReady()
    })
  }, [onCallback, onExpiredCallback, onReady])

  useEffect(() => {
    if (widgetId === -1) {
      window.captchaOnLoad = onLoad
      const url = 'https://www.google.com/recaptcha/api.js'
      const queryString = '?onload=captchaOnLoad&render=explicit'
      const aScript = document.createElement('script')
      aScript.type = 'text/javascript'
      aScript.src = url + queryString
      aScript.async = true
      aScript.defer = true

      document.head.appendChild(aScript)
    } else {
      window.grecaptcha.reset(widgetId)
    }
  }, [onLoad, widgetId])

  // ..
  return <Div id="google-recaptcha" className=""></Div>
}
